/**
 * Extract a user-facing message from any error thrown by an axios call.
 *
 * Backend responses vary in shape:
 *   - { message: "Cannot archive ..." }  (most routes — see swagger)
 *   - { error: "Invalid or expired token" }  (auth middleware)
 *   - { errors: [{ msg: "..." }, ...] }  (express-validator)
 *
 * This helper checks each known shape and falls back to the supplied
 * default. Use anywhere a try/catch surfaces an error to the user via
 * toast, banner, or inline field error.
 *
 * Example:
 *   try {
 *     await mutation.mutateAsync(payload);
 *   } catch (err) {
 *     toast.error("Couldn't save", {
 *       description: getApiErrorMessage(err, "Please try again."),
 *     });
 *   }
 */
import { friendlyErrorMessage } from "./friendly-error";

export function getApiErrorMessage(err: unknown, fallback: string): string {
  // One translation for the whole app — see utils/friendly-error.ts.
  return friendlyErrorMessage(err, fallback);
}
